<p-messages
    [id]="id + '-' + alertType + '-alert'"
    [ngClass]="alertType === alertTypes.DEFAULT ? 'default-alert' : 'secondary-alert'"
    [severity]="alertSeverityType === alertSeverityTypes.CUSTOM ? alertSeverityTypes.INFO : alertSeverityType"
    [class.custom-alert]="alertSeverityType === alertSeverityTypes.CUSTOM"
    [class.custom-content]="!content">
    <ng-template pTemplate>
        <i
            [id]="id + '-' + alertType + '-alert-icon'"
            class="fa-regular"
            [class.fa-circle-exclamation]="alertSeverityType === alertSeverityTypes.INFO"
            [class.fa-triangle-exclamation]="alertSeverityType === alertSeverityTypes.WARNING"
            [class.fa-do-not-enter]="alertSeverityType === alertSeverityTypes.ERROR"
            [class.fa-square-check]="alertSeverityType === alertSeverityTypes.SUCCESS"
            [class.fa-megaphone]="alertSeverityType === alertSeverityTypes.CUSTOM">
        </i>

        <div class="alert-content">
            @if (content) {
                <p [id]="id + '-' + alertType + '-alert-content'" [innerHTML]="content | translate"></p>
            }

            <ng-content [select]="'alert-content'"></ng-content>
        </div>

        @if (closable) {
            <p-button
                (click)="closeEvent.emit()"
                id="close-alert-button"
                [text]="true"
                severity="secondary"
                icon="fa-regular fa-xmark">
            </p-button>
        }
    </ng-template>
</p-messages>
